import thunkMiddleware from 'redux-thunk';
import { compose, createStore, applyMiddleware } from 'redux';
import logger from 'redux-logger';
import { initialState } from 'app/modules';
import reducer from 'app/modules';
import analyticsMiddleware from 'middleware/analyticsMiddleware';
import publicEventsMiddleware from 'middleware/publicEventsMiddleware';
import { platforms } from '../enums/app';
import webkitMiddleware from 'middleware/webkitMiddleware';
import androidInterfaceMiddleware from 'middleware/androidInterfaceMiddleware';
import storageMiddleware, { getStoredInitialState } from 'middleware/storageMiddleware';
import merge from 'lodash.merge';

export default function configureStore(context) {
  const { deviceConfig } = context;
  const middlewares = [];

  let state = applyDeviceConfig(initialState, deviceConfig);
  state.configuration.configurationOverride = deviceConfig.configurationOverride || {};
  state = merge(state, getStoredInitialState(context.gateways.storageGateway));

  if (deviceConfig.platform === platforms.IOS) {
    middlewares.push(webkitMiddleware(context));
  } else if (deviceConfig.platform === platforms.ANDROID) {
    middlewares.push(androidInterfaceMiddleware(context));
  }

  middlewares.push(thunkMiddleware.withExtraArgument({ ...context.gateways }));
  middlewares.push(analyticsMiddleware(context));

  middlewares.push(publicEventsMiddleware(context));
  // middlewares.push(errorMiddleware(context)); // Temporary disabled until we fix Sentry client
  middlewares.push(storageMiddleware(context.gateways.storageGateway));

  if (process.env.NODE_ENV === `development`) {
    middlewares.push(logger);
  }

  return compose(applyMiddleware(...middlewares))(createStore)(reducer, state);
}

function applyDeviceConfig(state, deviceConfig) {
  if (!deviceConfig) {
    return state;
  }

  const deviceState = {
    app: {
      deviceId: deviceConfig.deviceId,
      deviceManufacturer: deviceConfig.deviceManufacturer,
      deviceModel: deviceConfig.deviceModel,
      os: deviceConfig.os,
      osVersion: deviceConfig.osVersion,
      platform: deviceConfig.platform,
      sdkVersion: deviceConfig.sdkVersion,
    },
  };

  return merge(state, deviceState);
}
